<template>
    <div v-if="result" class="timesheet-bulk-result" role="status">
        <span>{{ result.date }}: заполнено {{ result.saved }}, пропущено {{ result.skipped }}.</span>
        <details v-if="result.skipped_entries && result.skipped_entries.length">
            <summary>Кто пропущен и почему</summary>
            <ul><li v-for="item in result.skipped_entries" :key="item.line_id"><EmployeeLink :employee-id="item.employee_id" :fallback="item.employee_name" compact open-in-panel /> — {{ item.reason }}</li></ul>
        </details>
    </div>
</template>
<script>
import EmployeeLink from '@/components/EmployeeLink.vue';
export default {
    components: {EmployeeLink},props: {result: {type: Object, default: null}}};
</script>
<style scoped>
.timesheet-bulk-result { flex-basis: 100%; min-width: 0; font-size: 12px; overflow-wrap: anywhere; }
summary { cursor: pointer; }
ul { max-height: 180px; overflow: auto; padding-left: 20px; margin: 4px 0; }
</style>
